import { Outlet } from "react-router-dom";
import { colors } from "@/theme/colors.ts";

export default function AuthLayout() {
  return (
    <div
      className="flex items-center justify-center"
      style={{ background: colors.navDark }}
    >
      <Outlet />
    </div>
  );
}
